import { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from 'config';
import { parseGeoInfo, ParsedGeoInfo } from 'models/geoInfo';
import querystring from 'querystring';
import { HttpClient, QueryOptions } from './api-types';

const API_URL = config.api.geoApiUrl;
const GEO_API_KEY = config.geoApiKey;

export const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
    headers: { 'x-api-key': GEO_API_KEY },
  };
  if (options) {
    if (options.params) request.params = options.params;
    request.headers = {
      ...request.headers,
      ...options.headers,
    };
    if (options.data) {
      request.data = querystring.stringify(
        options.data as querystring.ParsedUrlQueryInput,
      );
      request.headers = {
        ...request.headers,
        'content-type': 'application/x-www-form-urlencoded',
      };
    }
  }

  return httpClient(request);
};

export const fetchGeoInfoApi = async (
  httpClient: HttpClient,
): Promise<ParsedGeoInfo> => {
  const response = await queryApi(httpClient, API_URL);
  const { data: result } = response;
  return parseGeoInfo(result);
};
